<template>
	<div>
		<!-- 加盟弹窗 -->
		<el-dialog width="403px" :visible.sync="show" :append-to-body="true" @close="close()" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="logout_dialog_box">
				<div class="logout_dialog_title">
					Are you sure to exit
				</div>

				<div class="logout_dialog_btn_box">
					<div class="logout_dialog_btn flex_as_c" @click="close()">
						exit
					</div>
					<div @click="logOut()" class="logout_dialog_btn flex_as_c logout_dialog_btn_h">
						cancel
					</div>
				</div>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		name: 'logoutDialog',
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				curTab: 1,
				tabList: [{
						id: 1,
						name: 'PANEL'
					},
					{
						id: 2,
						name: 'FAQ'
					},
					{
						id: 3,
						name: 'TUTORIAL'
					}
				]
			}
		},
		methods: {
			navTo(url, que = {}) {
				this.$router.push({
					name: url,
					query: que
				})
			},
			close() {
				this.$emit('close')
			},
			clickTab(item) {
				this.curTab = item.id
			},
			logOut(){
				this.close()
				this.navTo('login')
			}
			

		},
	}
</script>

<style scoped lang="scss">
	.logout_dialog_box {
		position: absolute;
		left: 0;
		top: 0;
		width: 403px;
		min-width: 403px;
		min-height: 241px;
		max-height: 700px;
		background: #1F242F;
		border-radius: 18px;
		max-height: 700px;
		overflow-y: auto;
		-ms-overflow-style: none;
		scrollbar-width: none;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.logout_dialog_box {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		text-align: center;
		box-sizing: border-box;
		padding: 56px 28px 26px;
	}

	.logout_dialog_title {
		font-weight: 500;
		font-size: 23px;
		color: #FFFFFF;
		line-height: 30px;
	}

	.logout_dialog_btn_box {
		display: flex;
		justify-content: space-between;
		text-align: center;
	}

	.logout_dialog_btn {
		width: 154px;
		height: 40px;
		background: rgba(255, 255, 255, 0.2);
		border-radius: 8px;
		font-weight: bold;
		font-size: 16px;
		color: #A2B4D1;
		cursor: pointer;
	}
	.logout_dialog_btn_h{
		color: #FFFFFF;
		background: linear-gradient( 118deg, #B2EB14 0%, #17CB67 25%, #19AB89 100%);
	}
</style>